"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var elementStateUtils_1 = require("../../elementStateUtils");
// eslint-disable-next-line import/no-cycle -- ok because ReadMore can display content via TaskContent
var TaskElement_1 = __importDefault(require("./TaskElement"));
var FormValidation_1 = __importDefault(require("./FormValidation"));
var styles = function (theme) { return (0, core_1.createStyles)({
    validationText: {
        marginTop: theme.spacing(4),
        textAlign: 'center',
        width: '100%',
        outline: 'none',
    },
}); };
var TaskContent = /** @class */ (function (_super) {
    __extends(TaskContent, _super);
    function TaskContent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            showValidationErrors: false,
        };
        _this.validationRef = React.createRef();
        _this.validate = function () {
            var _a;
            _this.setState({ showValidationErrors: true });
            return (_a = _this.validationRef.current) === null || _a === void 0 ? void 0 : _a.validate();
        };
        _this.validateAndSave = function (callback, submit) {
            if (_this.validate()) {
                if (_this.props.onSaveChanges) {
                    _this.props.onSaveChanges(callback, submit);
                }
            }
        };
        _this.submitForm = function (callback) {
            if (_this.validate()) {
                if (_this.props.onSaveChanges) {
                    _this.props.onSaveChanges(function () {
                        _this.setState({ showValidationErrors: false });
                        if (callback) {
                            callback();
                        }
                    }, true);
                }
            }
        };
        _this.saveWithoutValidation = function (callback) {
            if (_this.props.onSaveChanges) {
                _this.props.onSaveChanges(callback);
            }
        };
        return _this;
    }
    TaskContent.prototype.render = function () {
        var _this = this;
        var _a = this.props, className = _a.className, classes = _a.classes, task = _a.task, taskResponses = _a.taskResponses, noContent = _a.noContent, TaskFormProps = _a.TaskFormProps, LinkElementProps = _a.LinkElementProps, showTitle = _a.showTitle, getProgramItem = _a.getProgramItem, getSpecificTaskResponses = _a.getSpecificTaskResponses, onResponse = _a.onResponse, TaskElementProps = _a.TaskElementProps, changeId = _a.changeId;
        if (!task) {
            return null;
        }
        var taskElements = task.contentElements || [];
        (0, elementStateUtils_1.updateAllOthersAreHiddenProperties)(task, getSpecificTaskResponses, getProgramItem);
        return (React.createElement("div", { className: className },
            React.createElement(React.Fragment, null,
                showTitle && (React.createElement(core_1.Typography, { variant: "h4", className: classes.title }, task.name)),
                taskElements.length === 0
                    ? noContent
                    : taskElements.map(function (item, index) { return (React.createElement(TaskElement_1.default, __assign({ key: "".concat(task.elementId, "-").concat(task.id, "-").concat(item.id), task: task, getProgramItem: getProgramItem, getSpecificTaskResponses: getSpecificTaskResponses, element: item, taskResponses: taskResponses, TaskFormProps: TaskFormProps, LinkElementProps: LinkElementProps, elementIndex: index, onResponse: onResponse, showValidationErrors: _this.state.showValidationErrors }, TaskElementProps))); })),
            React.createElement(FormValidation_1.default, { ref: this.validationRef, task: task, responses: taskResponses, changeId: changeId, showValidations: this.state.showValidationErrors, getProgramItem: getProgramItem, getSpecificTaskResponses: getSpecificTaskResponses })));
    };
    return TaskContent;
}(React.Component));
// @ts-ignore // Typescript doesn't recognise defaultProps for Class Components??
TaskContent.defaultProps = {
    className: null,
    noContent: null,
    taskResponses: null,
    TaskFormProps: null,
    LinkElementProps: null,
    showTitle: false,
    elementPreContent: null,
    task: null,
    TaskElementProps: null,
    changeId: null,
    onSaveChanges: null,
    ref: null,
};
exports.default = (0, core_1.withStyles)(styles)(TaskContent);
